import { getUser } from "../../utils";
import { useReferralCustomer } from "../useReferralCustomer";
export const useReferralCode = () => {
    const { ciam_token, uuid } = getUser();
    const { data, isLoading } = useReferralCustomer({ uuid: uuid || "", ciam_token: ciam_token });
    return { code: (data === null || data === void 0 ? void 0 : data.code) || "", isLoading };
};
//# sourceMappingURL=useReferralCode.js.map